import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './Card';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Robert M.',
  quote: "I had burning in my feet so bad I couldn't sleep. After 3 weeks of treatment, the burning is completely gone. I'm finally sleeping through the night again."
}, {
  name: 'Susan D.',
  quote: 'My balance was terrible, and I was terrified of falling. The numbness has improved significantly, and I feel steady on my feet for the first time in years.'
}, {
  name: 'James T.',
  quote: 'I was told I just had to live with the pain and take pills. This clinic gave me my life back. The staff is wonderful and the treatments actually work.'
}];
export function Testimonials() {
  return <section id="results" className="py-20 bg-muted/30" data-id="element-213">
      <div className="container mx-auto px-4" data-id="element-214">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-215">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4 text-foreground" data-id="element-216">
            Real Patients. Real Results.
          </h2>
          <p className="text-lg text-muted-foreground" data-id="element-217">
            Don't just take our word for it. Hear from people right here in St.
            Augustine who have reclaimed their lives from neuropathy.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-218">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} data-id="element-219">
              <Card className="h-full border-muted/50" data-id="element-220">
                <CardContent className="p-8 flex flex-col gap-6" data-id="element-221">
                  <div className="flex gap-1" data-id="element-222">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-primary text-primary" data-id="element-223" />)}
                  </div>
                  <p className="text-lg italic text-muted-foreground flex-grow" data-id="element-224">
                    "{testimonial.quote}"
                  </p>
                  <p className="font-bold text-foreground" data-id="element-225">
                    — {testimonial.name}
                  </p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}